/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseMultiFileFieldDisplayType } from './DatabaseMultiFileFieldDisplayType';
import {
    DatabaseMultiFileFieldDisplayTypeFromJSON,
    DatabaseMultiFileFieldDisplayTypeFromJSONTyped,
    DatabaseMultiFileFieldDisplayTypeToJSON,
} from './DatabaseMultiFileFieldDisplayType';

/**
 * 
 * @export
 * @interface DatabaseMultiFileField
 */
export interface DatabaseMultiFileField extends DatabaseField {
    /**
     * 
     * @type {DatabaseMultiFileFieldDisplayType}
     * @memberof DatabaseMultiFileField
     */
    displayType?: DatabaseMultiFileFieldDisplayType;
    /**
     * Maximale Anzahl der Dateien
     * @type {number}
     * @memberof DatabaseMultiFileField
     */
    maxFiles?: number;
}

/**
 * Check if a given object implements the DatabaseMultiFileField interface.
 */
export function instanceOfDatabaseMultiFileField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseMultiFileFieldFromJSON(json: any): DatabaseMultiFileField {
    return DatabaseMultiFileFieldFromJSONTyped(json, false);
}

export function DatabaseMultiFileFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseMultiFileField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'displayType': !exists(json, 'displayType') ? undefined : DatabaseMultiFileFieldDisplayTypeFromJSON(json['displayType']),
        'maxFiles': !exists(json, 'maxFiles') ? undefined : json['maxFiles'],
    };
}

export function DatabaseMultiFileFieldToJSON(value?: DatabaseMultiFileField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'displayType': DatabaseMultiFileFieldDisplayTypeToJSON(value.displayType),
        'maxFiles': value.maxFiles,
    };
}

